module.exports = __webpack_public_path__ + "static/media/mobile-card.a0e77b77.svg";